import { useSchemaDB } from 'hooks/useSchemaDB'
import React from 'react'

const Home = () => {
    
    const {getTable, getListField, getProperty } = useSchemaDB({nameTable:""})
    
    
    return (
        <div>
            Bienvenid@ a Verbo 8
        </div>
    )
}

export default Home
